import { Modal, PDFRenderer } from "components";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

import config from "config";

export default function ViewInsurerPaymentScheduleContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useAppSearch();
  const { params } = useAppLocation();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Payment Schedule"
      description="Details of payment schedule are shown below"
    >
      <PDFRenderer
        url={`${config.asset.uri}payment_schedule/${btoa(
          JSON.stringify({
            offer_id: params?.offer,
            payment_id: JSON.stringify([searchParams?.id]),
          })
        )}`}
      />
    </Modal>
  );
}
